import { setHours } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const isDateWithinRange = (startDate, endDate, dateSubmitted) =>
  dateSubmitted >= startDate && dateSubmitted <= endDate;

export const toTimeZoneString = ({ date, timeZone }) =>
  zonedTimeToUtc(setHours(date, 0), timeZone).toISOString();
